import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const generatePrompts = unaryRpc({
  name: "generatePrompts",
  input: z.object({
    teamId: zExt.objectId(),
    numberOfPrompts: z.number().int().positive().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    prompts: z
      .array(z.object({ prompt: z.string(), category: z.string() }))
      .optional(),
    error: z.string().optional(),
  }),
});
